import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
	addBusinessFundDetailsFailure,
	addBusinessFundDetailsResponseChanged,
	addBusinessFundDetailsSuccess,
	deleteBusinessFundDetailsFailure,
	deleteBusinessFundDetailsResponseChanged,
	deleteBusinessFundDetailsSuccess,
	fetchAllBusinessFundListFailure,
	fetchAllBusinessFundListResponseChanged,
	fetchAllBusinessFundListSuccess,
	fetchBusinessFundDetailsFailure,
	fetchBusinessFundDetailsResponseChanged,
	fetchBusinessFundDetailsSuccess,
	getBusinessFundListFailure,
	getBusinessFundListResponseChanged,
	getBusinessFundListSuccess,
	updateBusinessFundDetailsFailure,
	updateBusinessFundDetailsResponseChanged,
	updateBusinessFundDetailsSuccess,
} from './business-fund.action';
import { encryptData } from '../../_common/enode-decode';
import AlertManager from '../../../utils/alertManager';
import businessFundActionTypes from './business-fund.types';
import {
	allbusinessfundFetch,
	businessfundDetailsAdd,
	businessfundDetailsDelete,
	businessfundDetailsFetch,
	businessfundDetailsUpdate,
	businessfundListGet,
} from './business-fund.services';

/** *********************  START ADD BUSINESS FUND DETAILS  ******************** */
export function* createBusinessFund({ payload }: any) {
	try {
		const key = 'AddBusinessFundDetailKey';
		const jsonData = {
			BusinessType: payload.businessType,
			FundName: payload.fundName,
			Description: payload.description,
			Amount: payload.amount,
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			UserAccessBranchID: payload.userAccessBranchID,
			UserName: payload.userName,
			CreatedBy: payload.userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessfundDetailsAdd, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(addBusinessFundDetailsFailure(responseData.data));
		} else {
			yield put(addBusinessFundDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(addBusinessFundDetailsFailure(error));
	}
}

export function* resetAddBusinessFundResponse() {
	yield put(addBusinessFundDetailsResponseChanged());
}

export function* onCreateBusinessFundDetails() {
	yield takeLatest(businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_START, createBusinessFund);
}

export function* onCreateBusinessFundResponseReset() {
	yield takeLatest(
		businessFundActionTypes.ADD_BUSINESS_FUND_DETAILS_RESPONSE_RESET,
		resetAddBusinessFundResponse,
	);
}
/** *********************  END ADD BUSINESS FUND DETAILS ******************** */

/** *********************  START UPDATE BUSINESS FUND DETAILS  ******************** */
export function* businessfundUpdate({ payload }: any) {
	try {
		const key = 'UpdateBusinessFundDetailsKey';
		const jsonData = {
			BusinessFundID: payload.businessfundID,
			BusinessType: payload.businessType,
			FundName: payload.fundName,
			Description: payload.description,
			Amount: payload.amount,
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			UserAccessBranchID: payload.userAccessBranchID,
			UserName: payload.userName,
			CreatedBy: payload.userID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessfundDetailsUpdate, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateBusinessFundDetailsFailure(responseData.data));
		} else {
			yield put(updateBusinessFundDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateBusinessFundDetailsFailure(error));
	}
}

export function* resetUpdateBusinessFundDetailsResponse() {
	yield put(updateBusinessFundDetailsResponseChanged());
}

export function* onUpdateBusinessFundDetails() {
	yield takeLatest(
		businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_START,
		businessfundUpdate,
	);
}

export function* onUpdateBusinessFundResponseReset() {
	yield takeLatest(
		businessFundActionTypes.UPDATE_BUSINESS_FUND_DETAILS_RESPONSE_RESET,
		resetUpdateBusinessFundDetailsResponse,
	);
}
/** *********************  END UPDATE BUSINESS FUND DETAILS ******************** */

/** *********************  START GET BUSINESS FUND LIST  ******************** */
export function* businessfundDetailsListGet({ payload }: any) {
	try {
		const key = 'GetBusinessFundListKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
			InputSearch: payload.searchValueSet,
			Limit: payload.limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessfundListGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getBusinessFundListFailure(responseData.data));
		} else {
			yield put(getBusinessFundListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getBusinessFundListFailure(error));
	}
}

export function* resetGetBusinessFundListResponse() {
	yield put(getBusinessFundListResponseChanged());
}

export function* onGetBusinessFundListDetails() {
	yield takeLatest(
		businessFundActionTypes.GET_BUSINESS_FUND_LIST_START,
		businessfundDetailsListGet,
	);
}

export function* onGetBusinessFundListResponseReset() {
	yield takeLatest(
		businessFundActionTypes.GET_BUSINESS_FUND_LIST_RESPONSE_RESET,
		resetGetBusinessFundListResponse,
	);
}
/** *********************  END GET BUSINESS FUND LIST ******************** */

/** *********************  START FETCH BUSINESS FUND DETAILS  ******************** */
export function* fetchBusinessFundData({ payload }: any) {
	try {
		const key = 'FetchBusinessFundDetailsKey';
		const jsonData = {
			CompanyID: payload.companyID,
			BusinessFundID: payload.businessfundID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessfundDetailsFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchBusinessFundDetailsFailure(responseData.data));
		} else {
			yield put(fetchBusinessFundDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchBusinessFundDetailsFailure(error));
	}
}

export function* resetFetchBusinessFundDetailsResponse() {
	yield put(fetchBusinessFundDetailsResponseChanged());
}

export function* onFetchBusinessFundDetails() {
	yield takeLatest(
		businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_START,
		fetchBusinessFundData,
	);
}

export function* onFetchBusinessFundResponseReset() {
	yield takeLatest(
		businessFundActionTypes.FETCH_BUSINESS_FUND_DETAILS_RESPONSE_RESET,
		resetFetchBusinessFundDetailsResponse,
	);
}
/** *********************  END FETCH BUSINESS FUND DETAILS ******************** */

/** *********************  START DELETE BUSINESS FUND DETAILS  ******************** */
export function* businessfundDelete({ payload }: any) {
	try {
		const key = 'DeleteBusinessFundDetailsKey';
		const jsonData = {
			// CompanyID: payload.companyID,
			BusinessFundID: payload,
			IsActive: '0',
			// BusinessFundName: payload.businessfundName,
			// DatabaseName: payload.databaseName,
			// DeletedBy: payload.userID,
			// UserAccessBranchID: payload.userAccessBranchID,
			// UserName: payload.userName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(businessfundDetailsDelete, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteBusinessFundDetailsFailure(responseData.data));
		} else {
			yield put(deleteBusinessFundDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteBusinessFundDetailsFailure(error));
	}
}

export function* resetDeleteBusinessFundDetailsResponse() {
	yield put(deleteBusinessFundDetailsResponseChanged());
}

export function* onDeleteBusinessFundDetail() {
	yield takeLatest(
		businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_START,
		businessfundDelete,
	);
}

export function* onDeleteBusinessFundResponseReset() {
	yield takeLatest(
		businessFundActionTypes.DELETE_BUSINESS_FUND_DETAILS_RESPONSE_RESET,
		resetDeleteBusinessFundDetailsResponse,
	);
}
/** *********************  END DELETE BUSINESS FUND DETAILS ******************** */

/** *********************  START FETCH ALL BUSINESS FUNDS LIST  ******************** */
export function* fetchAllBusinessFundsList({ payload }: any) {
	try {
		const key = 'FetchAllBusinessFundsKey';
		const jsonData = {
			CompanyID: payload.companyID,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(allbusinessfundFetch, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAllBusinessFundListFailure(responseData.data));
		} else {
			yield put(fetchAllBusinessFundListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAllBusinessFundListFailure(error));
	}
}

export function* resetFetchAllBusinessFundsResponse() {
	yield put(fetchAllBusinessFundListResponseChanged());
}

export function* onFetchAllBusinessFundsDetails() {
	yield takeLatest(
		businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_START,
		fetchAllBusinessFundsList,
	);
}

export function* onFetchAllBusinessFundsResponseReset() {
	yield takeLatest(
		businessFundActionTypes.FETCH_ALL_BUSINESS_FUND_RESPONSE_RESET,
		resetFetchAllBusinessFundsResponse,
	);
}
/** *********************  END FETCH ALL BUSINESS FUNDS LIST ******************** */

export function* businessfundMasterSaga() {
	yield all([
		call(onCreateBusinessFundDetails),
		call(onCreateBusinessFundResponseReset),
		call(onUpdateBusinessFundDetails),
		call(onUpdateBusinessFundResponseReset),
		call(onGetBusinessFundListDetails),
		call(onGetBusinessFundListResponseReset),
		call(onFetchBusinessFundDetails),
		call(onFetchBusinessFundResponseReset),
		call(onDeleteBusinessFundDetail),
		call(onDeleteBusinessFundResponseReset),
		call(onFetchAllBusinessFundsDetails),
		call(onFetchAllBusinessFundsResponseReset),
	]);
}
